<label [ngClass]="{ 'm-t-md': toolTip, 'form-label': !toolTip }">
  <span class="radio" [ngClass]="{ disabled: disabled, 'border-red': errorBorderClass }">
    <input
      type="radio"
      [id]="id"
      [name]="name"
      [disabled]="disabled"
      (click)="onClick(values)"
      [checked]="values === selectedValue"
      [attr.aria-label]="ariaLabel"
      (focusout)="onFocusOut()"
    />
    <span class="radio-mask"></span>
  </span>
  <p class="content" [ngClass]="{ small: applySmallClass }"><ng-content></ng-content></p>
  <p
    *ngIf="secondaryText"
    class="content"
    [ngClass]="{ small: applySmallSecondaryClass, 'xsmall m-t-xs': !applySmallSecondaryClass }"
  >
    {{ secondaryText }}
  </p>
</label>
